import { createAction, createReducer } from '@reduxjs/toolkit'
import API from 'constants/api'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'

const tutorialRequested = createAction('resourcesRequested')
const tutorialReceived = createAction('resourcesReceived')
const tutorialFailed = createAction('resourcesFailed')

// REDUCER
export const initialState = {
  loading: false,
  data: {},
  tutorialSuccess: false
}

// tutorials
const tutorialReducer = createReducer(initialState, {
  [tutorialRequested.type]: (state) => {
    state.loading = true
    state.tutorialSuccess = false
  },
  [tutorialReceived.type]: (state, action) => {
    state.loading = false
    state.tutorialSuccess = true
    state.data = action.payload
  },
  [tutorialFailed.type]: (state, action) => {
    state.loading = false
    toast.error(action.payload.message)
  }
})

export default tutorialReducer

// tutorials
export const loadTutorial = (slug) => (dispatch, getState) => {
  const currentState = getState()
  const id = gameIdSelector(currentState)
  dispatch(
    apiCallBegan({
      baseURL: API.BASE_ADMIN_URL,
      url: `api/v1/resources/${slug}`,
      onStart: tutorialRequested.type,
      onSuccess: tutorialReceived.type,
      onError: tutorialFailed.type
    })
  )
}

